import { useIsSaber } from '../utils/qualSistema';
import configUrlSecretaria from './urls/configUrlSecretaria';

export const useSecretariaRoutes = () => {
  const isSaber = useIsSaber();

  // Base das rotas que não mudam

  // Rotas que mudam dependendo do layout
  const layoutPrefix = isSaber ? '/saber' : '/site/admin';

  return {
    SECRETARIA_CREATE: isSaber ? configUrlSecretaria.SECRETARIA_CREATE_SABER : configUrlSecretaria.SECRETARIA_CREATE_SITE,
    SECRETARIA_EDIT: isSaber ? configUrlSecretaria.SECRETARIA_EDIT_SABER : configUrlSecretaria.SECRETARIA_EDIT_SITE,
    SECRETARIA_LIST: isSaber ? configUrlSecretaria.SECRETARIA_LIST_SABER : configUrlSecretaria.SECRETARIA_LIST_SITE,
    SECRETARIA_EDIT_LK: isSaber ? configUrlSecretaria.SECRETARIA_EDIT_LK_SABER : configUrlSecretaria.SECRETARIA_EDIT_LK_SITE,
    SECRETARIA_API_EP: configUrlSecretaria.SECRETARIA_API_EP,
    SECRETARIA_FILTER_BY_SEARCH_EP: configUrlSecretaria.SECRETARIA_FILTER_BY_SEARCH_EP
  };
};
